import { render } from "./Principal-header.vue?vue&type=template&id=4b5a2956"
import script from "./Principal-header.vue?vue&type=script&lang=js"
export * from "./Principal-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__